
import mirador from 'mirador/dist/es/src/index';
import annotationPlugins from '../../src';
import AnnototAdapter from '../../src/AnnototAdapter';

const urlParams = new URLSearchParams(window.location.search);
const manifest = urlParams.get('manifest')

const endpointUrl = '/a/stock';
const config = {
  annotation: {
    adapter: (canvasId) => new AnnototAdapter(canvasId, endpointUrl),
  },
  id: 'demo',
  window: {
    defaultSideBarPanel: 'annotations',
    sideBarOpenByDefault: true,
    allowClose: false,
    defaultSideBarPanelWidth: 320,
    hideWindowTitle: true,
    defaultView: 'single',
    highlightAllAnnotations: true,
    views: [
      { key: 'single', behaviors: ['individuals'] }
    ],
  },
  windows: [{
    loadedManifest: manifest
  }],
};

mirador.viewer(config, [...annotationPlugins]);
